import { Container } from 'pixi.js';
import { PopupStackView } from '../../popups/PopupStackView';
import { registerResizableObject } from '../../utils/pixi/registerResizableObject';
import { ResourceAnimationsView } from '../resources/animations/ResourceAnimationsView';

export class AppOverlayView extends Container {
  public readonly popups = new PopupStackView().props({
    parent: this,
    zIndex: 0,
  });

  // Use this if adding children externally to properly layer into overlay.
  public readonly content = new Container().props({
    parent: this,
    zIndex: 2,
  });

  public readonly resourceAnimations: ResourceAnimationsView = new ResourceAnimationsView().props({
    parent: this,
    zIndex: 3,
  });

  constructor() {
    super();

    this.sortableChildren = true;
    this.sortChildren();

    registerResizableObject(this);
  }

  public update(deltaTime: number): void {
    this.resourceAnimations.update(deltaTime);
  }

  public resize(_width: number, _height: number): void {
    //
  }
}
